<template>
  <div class="pageContent inspect">
    <LoadingModal />
    <div v-if="!$store.state.pageLoading">
      <Top :title="name" :message="tips" v-if="tips != ''" />
      <VTitle val="请选择面值" :showLine="false" />
      <ProductDenoList
        :list="arryList"
        @selItem="handleSelList"
        :isMember="isMember"
        :active="activeicon2"
        :vip_discount="vip_discount"
      />
      <!-- <TypeList
        :status="radio"
        :list="selList"
        :activeIndex="selItem"
        @selItem="handleSel"
        :isMember="isMember"
        :canSel="canSel"
        :vip_discount="vip_discount"
      /> -->
      <VTitle val="车牌号" :showLine="false" />
      <div>
        <!-- <van-field
          v-model="account"
          class="pageBigRadius input"
          placeholder="请输入车牌号"
          :error-message="carNoErrorMsg"
          maxlength="8"
          @input="input"
          ref="accounts"
          id="accounts"
        /> -->
        <Keyboards @sendCarNumber="getcrNumber"></Keyboards>
      </div>
      <VTitle val="支付方式" :showLine="false" />
      <PayWay
        ref="payway"
        :sellData="sellData"
        :tips="tips"
        :discount="discount"
        :isWechatPay="wechatpay"
        :type="8"
        :params="params"
        :isSend="isSend"
        :balance="balance"
        :couponsId="couponsId"
        :couponsName="couponsName"
        :isMember="isMember"
        :vip_discount="vip_discount"
        :discount_coupons="discount_coupons"
        :can_use_power="can_use_power"
        :couponsBalanceList="couponsBalanceList"
        :couponsDeduct="couponsDeduct"
        @onComfirm="payHandle"
      />
      <!-- <Tips :content="describe">
        <div slot="content">
          <ul
            style="
              list-style: disc;
              color: #000;
              opacity: 0.53;
              margin-left: 15px;
            "
          >
            <li style="list-style: disc">
              <b>兑换流程：</b>
              <p>
                打开天猫养车APP→手机登录后，首页进入“我的”→选择“权益兑换”→输入兑换码完成兑换→在“我的套餐卡”查看。
              </p>
              <b>使用流程：</b>
              <p>
                打开天猫养车APP→手机登录后，首页进入“我的”→在“我的套餐卡”查看，点击对应服务→预约→选址门店和时间到店服务
              </p>
            </li>
          </ul>
        </div>
      </Tips> -->
    </div>
  </div>
</template>

<script>
import { getProductList } from "api/onLine";
import { couponExchange } from "api/offLine";
import ProductDenoList from "../onLine/ProductDenoList";
import Keyboards from "./components/keyboard.vue";

export default {
  props: {
    type: String,
    name: String,
    cid: Number,
    balance: Number,
    couponsId: String,
    couponsName: String,
    couponsDeduct: Number,
    isMember: Boolean,
    ident: String,
    mouldId: String,
    couponsBalanceList: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    ProductDenoList,
    Keyboards,
  },
  data() {
    return {
      appimg: require("assets/sy.png"),
      radio: 0,
      area: "",
      // 数据列表
      arryList: [],
      inspectList: [
        {
          productCustomerPrice: "110.000",
          productDenomination: "110.000",
          productFlowVal: "",
          productId: "b01",
          productIsAnyDeno: 0,
          productName: "取送车年检代为办理",
          productNo: "10",
          productPrimePrice: "110.000",
          productStatus: 1,
          productStock: 50,
        },
        {
          productCustomerPrice: "50.000",
          productDenomination: "50.000",
          productFlowVal: "",
          productId: "b02",
          productIsAnyDeno: 0,
          productName: "自驾到站代为办理年检",
          productNo: "11",
          productPrimePrice: "50.000",
          productStatus: 1,
          productStock: 30,
        },
        {
          productCustomerPrice: "20.000",
          productDenomination: "20.000",
          productFlowVal: "",
          productId: "b03",
          productIsAnyDeno: 0,
          productName: "年检标办理",
          productNo: "12",
          productPrimePrice: "20.000",
          productStatus: 1,
          productStock: 10,
        },
      ],
      safeStopList: [
        {
          productCustomerPrice: "61.000",
          productDenomination: "61.000",
          productFlowVal: "",
          productId: "b01",
          productIsAnyDeno: 0,
          productName: "安全停靠",
          productNo: "10",
          productPrimePrice: "61.000",
          productStatus: 1,
          productStock: 50,
        },
      ],
      drivingProtectList: [
        {
          productCustomerPrice: "204.000",
          productDenomination: "204.000",
          productFlowVal: "",
          productId: "b01",
          productIsAnyDeno: 0,
          productName: "驾驶护航",
          productNo: "10",
          productPrimePrice: "204.000",
          productStatus: 1,
          productStock: 50,
        },
      ],
      moveCarServiceList: [
        {
          productCustomerPrice: "3.000",
          productDenomination: "3.000",
          productFlowVal: "",
          productId: "b01",
          productIsAnyDeno: 0,
          productName: "挪车服务",
          productNo: "10",
          productPrimePrice: "3.000",
          productStatus: 1,
          productStock: 50,
        },
      ],
      violationSearchList: [
        {
          productCustomerPrice: "1.000",
          productDenomination: "1.000",
          productFlowVal: "",
          productId: "b01",
          productIsAnyDeno: 0,
          productName: "违章查询",
          productNo: "10",
          productPrimePrice: "1.000",
          productStatus: 1,
          productStock: 50,
        },
      ],
      selList: [],
      activeicon2: -1,
      selItem: null,
      canSel: false, // 整个列表是否可选
      selListDefaultData: [],
      // 支付数据
      sellData: { sell_price: -1 },
      tips: "",
      describe: "",
      discount: 0,
      index: 0,
      wechatpay: false,
      account: "",
      params: { productId: "" },
      sms: "",
      isSend: true,
      data: {},
      vip_discount: 0,
      discount_coupons: [],
      can_use_power: false,
      carNoErrorMsg: "",
      isValid: false,
      showKeyboard: false,
    };
  },
  created() {
    this.$store.commit("setPageLoading", false);
  },
  mounted() {
    this.loadData();
  },
  methods: {
    resetData() {
      this.selList = this.selListDefaultData.list;
      this.canSel = false;
      this.selItem = null;
      this.sellData = { sell_price: -1 };
    },
    getcrNumber(val) {
      if (this.$regCarNo(val)) {
        this.account = val;
        this.params.account = this.account;
      }
    },
    loadData() {
      if (this.ident === "inspect") {
        this.arryList = this.inspectList;
      } else if (this.ident === "safeStop") {
        this.arryList = this.safeStopList;
      } else if (this.ident === "drivingProtect") {
        this.arryList = this.drivingProtectList;
      } else if (this.ident === "moveCarService") {
        this.arryList = this.moveCarServiceList;
      } else if (this.ident === "violationSearch") {
        this.arryList = this.violationSearchList;
      }
      // getProductList(this.ident, this.mouldId).then((res) => {
      //   this.$clear();
      //   if (res.status == 200) {
      //     if (typeof res.data == "object") {
      //       this.selList = res.data;
      //       this.canSel = true;
      //     }
      //   } else {
      //     this.resetData();
      //     this.$error(res.message);
      //   }
      //   this.$nextTick(() => {
      //     this.$store.commit("setPageLoading", false);
      //     this.$clear();
      //   });
      // });
    },
    input(value) {
      if (!this.$regCarNo(value)) {
        this.carNoErrorMsg = "车牌号格式错误";
        this.isValid = false;
      } else {
        this.carNoErrorMsg = "";
        this.isValid = true;
      }
      this.params.account = this.account;
    },
    handleSelList(i) {
      this.activeicon2 = i;
      this.sellData = {
        ...this.arryList[i],
        sell_price: Number(this.arryList[i].productCustomerPrice),
      };
      this.params.productId = this.arryList[i].productId;
      this.params.mouldId = this.mouldId;
    },
    handleSel(i) {
      this.selItem = i;
      this.sellData = {
        ...this.selList[i],
        sell_price: Number(this.selList[i].productCustomerPrice),
      };
      this.params.productId = this.selList[i].productId;
    },
    payHandle(data) {
      this.$loading("支付中");
      let params = {
        productId: this.params.productId,
        couponIds: data.couponIds,
      };
      couponExchange(params).then((res) => {
        if (res.status == 200) {
          this.$successSync("购买成功", () => {});
        } else {
          this.$error(res.message);
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.inspect {
}
</style>
